import { UseQueryResult, useQuery } from 'react-query';
import { AverageChurnReport, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAverageChurn {
  month: string | null;
  enabled?: boolean;
}

function useAverageChurn({
  month,
  enabled = true,
}: IUseAverageChurn): UseQueryResult<{ data: AverageChurnReport }> {
  const params: UrlParams = {};

  if (month) {
    params.month = month;
  }

  return useQuery(
    ['average-churn', month],
    () => client.get(`reports/average-churn?${encodeUrlParams(params)}`),
    {
      enabled: !!month && enabled,
      staleTime: 86400000, // 1 day
    },
  );
}

export default useAverageChurn;
